import "./semesters.css";
import { useContext, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import { TermsContext } from "../App";
import Loader from "../Components/utils/Loader";
import uuid from "react-uuid";

function Semesters() {
  const { terms, isLoading } = useContext(TermsContext);
  let [pageTitle, setPageTitle] = useState(`Class Schedule | Sacramento State`);
  let location = useLocation();

  document.title = pageTitle;

  return (
    <div className="page-schedule-home">
      <article role="region" aria-label="semesters">
        <h1 id="article-head">Class Schedule</h1>
        {isLoading ? (
          <Loader />
        ) : terms && terms.length > 0 ? (
          <ul aria-labelledby="article-head">
            {terms.map((term) => (
              <li key={uuid()}>
                <Link
                  to={`${term.term}`}
                  state={{ all_terms: terms, term_desc: term.term_ldesc }}
                >
                  {term.term_ldesc}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <h3>
            We are not able to currently not able to retrieve class information.
            Please try again later.
          </h3>
        )}
      </article>
    </div>
  );
}

export default Semesters;
